import React from 'react';
import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives/compiled';

import { ErrorDetail } from '@confluence/error-boundary/entry-points/ErrorDetail.ts';

import { i18n } from '../Error.tsx';
import SearchErrorImage from '../images/SearchErrorImage.svg';

const errorContainerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	width: '100%',
	padding: '32px 20px',
});

const errorImageStyles = css({
	width: '100px',
	height: 'auto',
});

export const RecentListError = (): React.JSX.Element => (
	<div css={errorContainerStyles}>
		<img src={SearchErrorImage} alt="" css={errorImageStyles} />
		<Heading size="small">
			<FormattedMessage {...i18n.errorHeader} />
		</Heading>
		<Box paddingBlockStart="space.100">
			<FormattedMessage {...i18n.errorAction} />
		</Box>
		<Box paddingBlockStart="space.100">
			<ErrorDetail />
		</Box>
	</div>
);
